<template>
  <p class="disable-selection" :class="{ inline: inline == true }">
    <router-link :to="to" v-if="to">{{ label }}</router-link>
    <a :href="href" v-if="href">{{ label }}</a>
  </p>
</template>

<script>
export default {
  name: "CustomLink",
  props: {
    label: String,
    href: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
p a {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
.inline {
  display: inline;
}
</style>
